import { redirectDocument, replace, type LoaderFunctionArgs } from "react-router";

type RedirectArgs = Pick<LoaderFunctionArgs, "params" | "request">;

const searchFrom = (request: Request) => new URL(request.url).search;

export const loginRedirect = ({ request }: RedirectArgs) => redirectDocument(`/authn/login${searchFrom(request)}`);

export const signupRedirect = ({ request }: RedirectArgs) => redirectDocument(`/authn/signup${searchFrom(request)}`);

export const documentsRedirect = ({ params, request }: RedirectArgs) =>
  replace(`/${params.customerDomain}/settings/company/documents${searchFrom(request)}`);

export const settingsRedirect = ({ params }: RedirectArgs) => replace(`/${params.customerDomain}/settings/company`);
